// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemDiscountColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the discount column for item subtables.
// Shows '—' when discount is zero/null; shows green value when discount exists.
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemDiscountColumn(options = {}) {
  const { size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title: translateX('discount_abbr'),
    dataIndex: 'discount',
    width: 70,
    align: 'right',
    sorter: (a, b) => (a?.discount || 0) - (b?.discount || 0),
    render: (_, item) => {
      const discount = item?.discount || 0;
      if (!discount) {
        return (
          <Text style={{ fontSize }} type="secondary">
            —
          </Text>
        );
      }
      return (
        <Text style={{ fontSize, color: '#52c41a' }}>
          {financialService.formatCurrency(discount)}
        </Text>
      );
    },
  };
}

export default itemDiscountColumn;
